<template>
  <!-- This is the bet display inside the Position Accordeon  !-->
  <div class="col-12 px-0">
    <my-position-accordeon-item
      v-for="(bet, bIx) in props.objSide.bets"
      :key="bIx"
      :obj-side="props.objSide"
      :bet="bet"
      :league="props.league"
      @display-bet="displayBet"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { calculateWin, getSideString } from '@/core/utils';
import MyPositionAccordeonItem from '@/components/userBets/MyPositionSingleBet.vue';

const props = defineProps({
  objSide: {
    type: Object,
    required: true,
  },
  typeBet: {
    type: String,
    default: 'spread',
  },
  league: {
    type: String,
    default: '',
  },
});

const away = ref([]);
const home = ref([]);
const accordeonOpened = ref(false);

const emit = defineEmits(['displayBet']);
function displayBet(bet) {
  //EventBus.main.$emit('displayBet', bet);
  emit('displayBet', bet);
}
</script>

<style scoped lang="scss">
@use '@/scss/tokens.scss' as main;

.bar-separate {
  text-align: center;
  font-size: 12px;
  color: main.$blue-202;
}
.button-back {
  width: 100%;
  background: main.$grey-500;
  color: main.$blue-1100;
  font-weight: bold;
}
.short-info {
  font-size: small;
  font-weight: bold;
  color: main.$blue-702;
  text-align: center;
}
.jump {
  min-width: 10%;
}
.iconAccordeon {
  color: main.$color-primary;
}
</style>
